import type {
  AlertFiltersResponse,
  AlertListParams,
  AlertMongoSummary,
  AlertNotificationStats,
  AlertNotificationStatsParams,
  DescribeAlertMongoResponse,
  UpdateAllFilteredAlertsParams,
} from "types/api/alertTypes";
import { ListAlertRequest } from "types/api/listAlertRequest";
import type { UpdateAlertRequest } from "types/api/updateAlertRequest";
import { PageResponse } from "types/pageResponse";
import { getStartAndEndDateForQuickOption } from "utils/dateUtils";

import { makeCancellableAPIRequest } from "./index";

const AlertsAPI = {
  getAll(params: AlertListParams, data: ListAlertRequest) {
    modifyFilters(data);
    return makeCancellableAPIRequest<PageResponse<AlertMongoSummary>>(
      "POST",
      "/api/alerts",
      {
        params,
        data,
      },
    );
  },
  getFilters() {
    return makeCancellableAPIRequest<AlertFiltersResponse>(
      "GET",
      "api/alerts/alert-filters",
    );
  },
  getUnreadAlertCount(params: AlertNotificationStatsParams) {
    modifyFilters(params);
    return makeCancellableAPIRequest<AlertNotificationStats>(
      "GET",
      "/api/alerts/alert-notification-stats",
      {
        params: {
          ...params,
          state: "UNREAD",
        },
      },
    );
  },
  markUnread(id: string) {
    return makeCancellableAPIRequest("PUT", `/api/alerts/update`, {
      data: {
        state: "UNREAD",
        id: [id],
      },
    });
  },
  updateMarkAsRead(id: string[]) {
    return makeCancellableAPIRequest("PUT", `/api/alerts/update`, {
      data: {
        state: "READ",
        id: id,
      },
    });
  },
  update(id: string, data: UpdateAlertRequest & { notes?: string }) {
    return makeCancellableAPIRequest<DescribeAlertMongoResponse>(
      "PUT",
      `api/alerts/${id}`,
      {
        data,
      },
    );
  },
  get(id: string) {
    return makeCancellableAPIRequest<DescribeAlertMongoResponse>(
      "GET",
      `api/alerts/${id}`,
    );
  },
  updateAllFilteredAlerts(params: UpdateAllFilteredAlertsParams) {
    return makeCancellableAPIRequest("PUT", `/api/alerts/`, {
      params,
    });
  },
};

export default AlertsAPI;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const modifyFilters = (params: any) => {
  if (
    params?.createdAt &&
    Array.isArray(params.createdAt) &&
    params.createdAt.length === 1
  ) {
    params.createdAt = getStartAndEndDateForQuickOption({
      label: params.createdAt[0],
      utcString: true,
    });
  }
};
